import React from 'react';
import { FormattedMessage } from 'react-intl';
import TuneIcon from '@mui/icons-material/Tune';
import { routePathMap } from '../common/routes/routePaths';
import TIRouteProps from '../common/routes/TIRouteProps';
import { SettingsPage } from './SettingsPage';
export const SettingPageRoute: TIRouteProps = {
  path: routePathMap.settings,
  component: SettingsPage,
  exact: false,
  title: <FormattedMessage id="tabs.settings" />,
  icon: <TuneIcon />
};
